import * as React from "react";

import { withTheme as withStyledComponentsTheme } from "styled-components";

export default function withTheme(Component: React.ComponentType<any>) {
  // withStyledComponentsTheme returns a ref rather than an actual React Component
  // which doesn't play nicely with Redux if we try and connect it. Hence here
  // we just ensure we return a React component than uses withStyledComponentsTheme
  // under the hood.
  const ThemedComponent = withStyledComponentsTheme(Component);
  return class WithTheme extends React.PureComponent<any> {
    render() {
      return <ThemedComponent {...this.props} />;
    }
  };
}
